import { createSlice } from '@reduxjs/toolkit';
import type { UserState } from './interfaces';
import { sharedActions } from './shared-actions';

const initialState: UserState = {
  roles: [],
  permissions: [],
  id: 0,
  identifier: '',
  username: '',
  email: '',
  metadata: {},
  profile: {
    firstName: '',
    lastName: '',
    name: '',
    photoUrl: '',
  },
  isFirstSession: false,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(sharedActions.appStateLoaded, (_, action) => {
      return action.payload.user;
    });
    builder.addCase(sharedActions.userLoggedOutAction, () => {
      return initialState;
    });
  },
});

export default userSlice.reducer;
